<template>
  <svg class="icon-cross" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M8.948 8l5.372 5.372a.67.67 0 1 1-.948.948L8 8.948 2.628 14.32a.67.67 0 1 1-.948-.948L7.052 8 1.68 2.628a.67.67 0 1 1 .948-.948L8 7.052l5.372-5.372a.67.67 0 1 1 .948.948L8.948 8z"
        :fill="color"/>
  </svg>
</template>

<script>
  export default {
    name: "IconCross",
    props: {
      color: {
        default: '#363636',
        type: String,
      }
    }
  }
</script>

<style scoped>

  .icon-cross {
    width: 0.16rem;
  }

</style>